"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSponsor = exports.sponsorContext = exports.SponsorContextProvider = void 0;
var _auth = require("@ori/auth");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _constants = require("../components/SponsorInfo/constants");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const sponsorContext = exports.sponsorContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const saveSessionStorage = () => {
  window.sessionStorage.setItem(_constants.SPONSOR_SESSION_STORAGE_KEY, 'true');
};
const SponsorContextProvider = ({
  children
}) => {
  const [animate, setAnimate] = (0, _react.useState)(false);
  const [isGiftIconVisible, setIsGiftIconVisible] = (0, _react.useState)(false);
  const {
    isAnonymousUser,
    isUserVerified
  } = (0, _auth.useToken)();
  const {
    owner: store
  } = (0, _hooks.useCookieStoreInfo)();
  const isAnonymousWithStore = (0, _react.useMemo)(() => isUserVerified && isAnonymousUser && !!store, [isAnonymousUser, store, isUserVerified]);
  const {
    open: sponsorBannerOpen,
    onClose: onSponsorBannerClose,
    onOpen: onSponsorBannerOpen
  } = (0, _presentationHooks.useDisclose)();
  const {
    open: topAreaBannerOpen,
    onClose: onTopAreaBannerClose,
    onOpen: onTopAreaBannerOpen
  } = (0, _presentationHooks.useDisclose)();
  (0, _react.useEffect)(() => {
    if (isAnonymousWithStore) {
      setIsGiftIconVisible(true);
      if (!window.sessionStorage.getItem(_constants.SPONSOR_SESSION_STORAGE_KEY)) {
        onSponsorBannerOpen();
      }
    }
  }, [isAnonymousWithStore, onSponsorBannerOpen]);
  const animateOnce = (0, _react.useCallback)(() => {
    setAnimate(true);
    setTimeout(() => {
      setAnimate(false);
    }, _constants.GIFT_ANIMATION_DURATION_SECONDS * (1000 * _constants.GIFT_ANIMATION_REPEAT_TIMES));
  }, []);
  const handleCloseSponsorBanner = (0, _react.useCallback)(() => {
    animateOnce();
    onSponsorBannerClose();
    onTopAreaBannerClose();
    saveSessionStorage();
  }, [animateOnce, onSponsorBannerClose, onTopAreaBannerClose]);
  const handleClickSponsorBanner = (0, _react.useCallback)(() => {
    onTopAreaBannerOpen();
    onSponsorBannerClose();
    saveSessionStorage();
  }, [onSponsorBannerClose, onTopAreaBannerOpen]);
  const memoizedValue = (0, _react.useMemo)(() => ({
    animate,
    sponsorBannerOpen,
    topAreaBannerOpen,
    handleCloseSponsorBanner,
    onTopAreaBannerClose,
    handleClickSponsorBanner,
    onTopAreaBannerOpen,
    isGiftIconVisible,
    onSponsorBannerClose
  }), [animate, sponsorBannerOpen, topAreaBannerOpen, handleCloseSponsorBanner, onTopAreaBannerClose, handleClickSponsorBanner, onTopAreaBannerOpen, isGiftIconVisible, onSponsorBannerClose]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(sponsorContext.Provider, {
    value: memoizedValue,
    children: children
  });
};
exports.SponsorContextProvider = SponsorContextProvider;
const useSponsor = () => {
  const context = (0, _react.useContext)(sponsorContext);
  if (context === undefined) {
    throw new Error('useSponsor must be used within a SponsorProvider');
  }
  return context;
};
exports.useSponsor = useSponsor;